export default {
    name: 'staff',
    namespaced: true,
    state() {
        return {
            orderInfo: {}
        }
    },
    getters: {},
    mutations: {
        setOrderInfo(state, payload) {
            state.orderInfo = payload;
        }
    },
    actions: {}
}
